import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const LevelFour = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.LEVEL_4} />
}

export default LevelFour;